import * as t from 'io-ts'
import { TransactionType } from '../TransactionType'
import { CashoutOptions } from './CashoutOptions'
import { Maybe } from '@mxt/zio/codec'
const Base = <C extends t.Mixed>(codec: C) => t.intersection([
  t.type({
    transactionType: t.literal(TransactionType.CANCEL_RIDER_FROM_INCEPTION)
  }),
  codec
])

export const CancelRiderFromInception = Base(t.type({
  payload: t.type({
    source: t.string,
    body: t.type({
      policy: t.type({
        policyNo: t.string
      }),
      attributesExt: t.type({
        RIDER_REFUND_AMOUNT: Maybe(t.number),
        SUSPENSE_AMOUNT: Maybe(t.number),
        REFUNDABLE_FEE_AMOUNT: Maybe(t.number),
        NET_AMOUNT_AVAILABLE: Maybe(t.number),
        TOTAL_PAYOUT_AMOUNT: Maybe(t.number),
        REASON: Maybe(t.string)
      }),
      cashOutOptions: Maybe(CashoutOptions),
      lifeAssureds: t.array(t.type({
        lifeAssured: t.string,
        riders: t.array(t.type({
          productCode: t.string,
          riskCommDate: t.string,
          riskCessDate: t.string,
          sumAssured: t.number,
          installmentPremium: t.number,
          lifeNo: t.string,
          coverageNo: t.string,
          riderNo: t.string,
          status: t.string,
        }))
      }))
    })
  })
}))

export type CancelRiderFromInception = t.TypeOf<typeof CancelRiderFromInception>